/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/random_user_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdRandomUserId } from "./constants";
import type { AppGroupRandomUserIdResult } from "./types";

export const getAppGroupRandomUserId = reactQueryFetcherAdapter(
  engagementAppGroupIdRandomUserId,
  (signal: AbortSignal, appGroupId: string): Promise<AppGroupRandomUserIdResult> => {
    return fetch(`/engagement/${appGroupId}/random_user_id`, "GET", {}, { signal });
  }
);
